/**
 * PDF / Excel dışa aktarma modülleri (pdfmake + 2,5 MB yazı tipi, xlsx) yalnız
 * ilk kullanımda yüklenir; ilk sayfa yükünü şişirmez.
 */
export const exportPdf = async (...args) =>
  (await import("./arrayToPdf")).arrayToPdf(...args);

export const exportExcel = async (...args) =>
  (await import("./arrayToExel")).arrayToExcel(...args);

export const exportPdfMerged = async (...args) =>
  (await import("./mergedPdf")).arrayToPdfMerged(...args);

export const exportExcelMerged = async (...args) =>
  (await import("./mergedExel")).arrayToExcelMerged(...args);
